import { render, staticRenderFns } from "./MatchingTypeSelect.vue?vue&type=template&id=40316568"
import script from "./MatchingTypeSelect.vue?vue&type=script&lang=js"
export * from "./MatchingTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports